<template>
  <div class="modal" style="display:block" v-if="vg_modal">
    <div class="modal-background"></div>
    <div class="modal-card is-small">
      <header class="modal-card-head">
        <button class="delete" @click.prevent="closeModal()" aria-label="close"></button>
        <p class="modal-card-title">Set Location</p>
      </header>
      <section class="modal-card-body">
        <!-- location field -->
        <div class="ph15 mb15">
          <div class="field">
            <label class="label">Where are you located?</label>
            <div class="control has-icon">
              <gmap-autocomplete
                id="set_location-autocomplete"
                class="nput has-bg-grey google-autocomplete has-text-black"
                style="height: 2.625rem; padding: 10px 20px 10px 45px; color: #666666; font-size: 0.9375rem; background-color: #f9f9f9; box-shadow: none; border-radius: 4px; border: none; width: 100%;"
                large
                placeholder="Enter a Location"
                @place_changed="setPlace"
                @keyup="resetPlace"
                :select-first-on-enter="true"
              ></gmap-autocomplete>

              <span class="icon" @click.prevent="locateUser()">
                <img src="@/assets/img/icon-location-purple.svg" alt="image" />
              </span>
            </div>
            <span
              style="font-size: 12px; color: #f00; padding-left: 20px;"
              v-if="emptyLocation"
            >Please enter location</span>
          </div>
        </div>
        <!-- location not found -->
        <div class="location-not-found" v-if="searchLocationText">
          <template v-if="selectedLocation.adr_address">
            <p v-html="selectedLocation.adr_address"></p>
          </template>
          <template v-else>
            <img src="@/assets/img/map.svg" alt="map" />
            <p>No Results Found.</p>
          </template>
        </div>
      </section>
      <footer class="modal-card-foot">
        <button
          @click.prevent="setAddress()"
          class="button is-large bg-secondary text-white hover-opacity-7 is-full-width"
        >Set Location</button>
      </footer>
    </div>
  </div>
</template>
<script>
import { isEmpty } from "lodash";
import { mapGetters, mapActions } from "vuex";
import LocationApis from '@/Components/Controllers/LocationApis.js';

export default {
  name: "SetUserAddress",
  data() {
    return {
      emptyLocation: false,
      searchLocationText: "",
      selectedLocation: {}
    };
  },

  watch: {
    modal(value) {
      // empty place
      this.resetPlace();
    }
  },

  computed: {
    locationName() {
      if (_.isEmpty(this.myLocation)) {
        return "Set Location";
      } else {
        return this.myLocation.name;
      }
    },
    ...mapGetters({
      vg_modal: "location/userAddressModal",
      vg_userAddress: "location/userAddress",
    })
  },

  methods: {  
    setAddress() {
      if (!_.isEmpty(this.selectedLocation)) {
        // Set user address obj
        this.va_setUserAddress(this.selectedLocation);
        this.emptyLocation = false;
        this.va_setModal(false);
      } else {
        this.emptyLocation = true;
      }
      this.closeModal();
    },
    setPlace: function(addressData) {
      if (addressData) {
        // hide error
        this.emptyLocation = false;
        // set address data
        this.searchLocationText = addressData.formatted_address;
        // set my location
        this.selectedLocation = addressData;
      }
    },
    
    resetPlace: function() {
      this.searchLocationText = "";
    },

    /**
     * Locate user from browser
     */
    async locateUser() {
      this.va_spinner(true);
      let res = await LocationApis.locateUser();
      this.va_spinner(false);
      if(res.status == 200) {
        this.va_setUserAddress({
          formatted_address: res.address,
          geometry: {
            location: {
              lat: res.lat,
              lng: res.lng,
            }
          },
        });
        this.closeModal();
      } 
      this.va_snackbar({
        message: res.message,
        type: res.status == 200 ? 'success' : 'warning',
      });
    },

    /**
     * Close modal
     */
    closeModal() {
      this.va_setModal(false);
      this.emptyLocation = false;
    },

    ...mapActions({
      va_spinner: "spinner/setSpinner",
      va_snackbar: "snackbar/setSnackbar",
      va_setModal: "location/setUserAddressModal",
      va_setUserAddress: "location/setUserAddress",
      // setNearByStore: "location/setNearby",
    })
  }
};
</script>